<ion-header>
  <ion-toolbar>
    <ion-title text-wrap>
      {{ 'TITLE.captureSignature' | translate }}
      @if (job) {
        for {{ job.riderFirstName }} {{ job.riderLastName }}
      }
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="signature-content" #signaturePageContent>
  <div class="buttons-wrapper" #buttonsWrapper>
    <ion-button
      color="danger"
      (click)="cancelClicked()"
      type="button"
      >
      {{ 'ACTION.cancel' | translate }}
    </ion-button>
    <ion-button
      class="clear-signature"
      fill="outline"
      color="warning"
      (click)="clearSignatureClicked()"
      [class.hidden]="!isSignatureDrawn"
      [disabled]="!isSignatureDrawn"
      type="button"
      >
      {{ 'ACTION.clearSignature' | translate }}
    </ion-button>
    @if (job && job.jobType != JobTypeEnum.DropOff) {
      <ion-button
        color="primary"
        (click)="captureSignatureAtDropoffClicked()"
        >
        <span class="hidden-sig">
          {{ 'ACTION.captureAtDropOff' | translate }}
        </span>
        <span class="show-sig">
          {{ 'LABEL.atDropoff' | translate }}
        </span>
      </ion-button>
    }

    <ion-button
      class="confirm"
      color="success"
      (click)="confirmClicked()"
      [disabled]="!isSignatureDrawn"
      >
      {{ 'ACTION.confirm' | translate }}
    </ion-button>
  </div>
  <div class="signature-wrapper" #signatureWrapper (window:resize)="onResize($event)">
    <div class="signature-prompt noselect" [class.hidden]="didStartSigning">
      {{ 'SIGNATURE.signHere' | translate }}
    </div>
    <signature-pad
      #refBugWorkAround
      [options]="signaturePadOptions"
      (drawStart)="onSignatureDrawStart()"
      (drawEnd)="onSignatureDrawComplete()"
    ></signature-pad>
  </div>

  @if (!job) {
    <div>
      {{ 'SIGNATURE.sigCertify' | translate }}
    </div>
  }
</ion-content>
